import { css, html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { errorIcon } from '../shared/icons/error';

@customElement('error-loading')
export class ErrorLoading extends LitElement {
  static readonly styles = css`
    :host {
      font-family: Roboto, sans-serif;

      --background-color: #fff;
      --spacing-vertical: 12px;
      --spacing-horizontal: 24px;
    }

    .error-loading {
      height: 400px;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 12px;
      flex-direction: column;
      width: 100%;
      background-color: #fff;
      border-radius: 12px;
      border: 1px solid #cacaca;
      box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0.2),
        0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
    }

    .error-loading .error {
      text-align: center;
    }

    .error-loading svg {
      width: 48px;
      height: 48px;
    }
  `;

  render() {
    return html`<div class="error-loading">
      ${errorIcon}
      <div class="error">Error loading files</div>
      <media-picker-button
        variant="primary"
        label="Retry"
        @click="${window.location.reload.bind(window.location)}"
      ></media-picker-button>
    </div>`;
  }
}
